import MicIcon from '@/assets/icons/mic.svg?react'

export const FindingSessionStep = () => {
  return (
    <div className="m-auto flex w-full max-w-[800px] flex-col items-center gap-4">
      <div className="flex w-full flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-8">
        <div className="flex flex-col items-center gap-4">
          <div className="text-body-2 text-gray-90 rounded-2xl border border-solid border-gray-100 p-2 px-3">
            Discuss the topic casually, like old acquaintances.
          </div>
          <div className="text-subtitle text-gray-70 font-semibold">Finding a session...</div>
          <div className="bg-black-to-white mt-4 flex size-24 items-center justify-center rounded-full">
            <div className="flex size-20 items-center justify-center rounded-full bg-gray-100">
              <MicIcon className="text-gray-80 size-10" />
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  )
}
